module.exports = __webpack_public_path__ + "img/exit4.9520f062.png";